<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Member Management Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label>First Name</label>
                <input type="text" class="form-control" disabled v-model="mm.firstName" id="firstName" aria-describedby="action">
            </div>
            <div class="form-group col-3">
                <label>Last Name</label>
                <input type="text" class="form-control" disabled v-model="mm.lastName" id="lastName" aria-describedby="action">
            </div>
            <div class="form-group col-3">
                <label for="module">Email</label>
                <input type="text" class="form-control" disabled v-model="mm.email" id="email" aria-describedby="module">
            </div>
            <div class="form-group col-3">
                <label>Verify By Member</label>
                <input type="checkbox" class="form-control" disabled v-model="mm.isVerifiedEmail" id="isVerifiedMember">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Department</label>
                <app-dropdown :id="'departmentId'" :keyName="'departmentId'" :model="mm.departmentId" :lists="departmentList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange"></app-dropdown>
            </div>
            <div class="form-group col-3">
                <label for="module">Division</label>
                <app-dropdown :id="'divisionId'" :keyName="'divisionId'" :model="mm.divisionId" :lists="divisionList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange"></app-dropdown>
            </div>
            <div v-if="this.mmRole === 'admin'" class="form-group col-3">
                <label for="role">Role</label>
                <app-dropdown :id="'role'" :keyName="'role'" :model="mm.role" :lists="roleList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange"></app-dropdown>
            </div>
            <div class="form-group col-3">
                <label>Verify by Admin</label>
                <input type="checkbox" class="form-control" v-model="mm.isVerified" id="isVerified">
            </div>
            <div class="form-group col-3">
                <label>Active</label>
                <input type="checkbox" class="form-control" v-model="mm.isActive" id="isActive">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
              <label for="head-dept">Head Dept</label>
              <app-lookup-field :model="mm" :element="headDeptLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
        </div>

        <!-- <app-datatable :type="'input'" :newData="newDetail" :elements="dtElements" :collections="mm.mailManagementDetail"></app-datatable> -->
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { memberManagement } from '../../models/memberManagement'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
    },
    data() {
        return {
            mm: {
                ...memberManagement
            },
            mmRole: '',
            departmentList: [],
            divisionList: [],
            roleList: [],
            headDeptLookup: {
              id: 'head-dept',
              title: 'Head Dept',
              type: 'form',
              apiUrl: 'member-management/lookup',
              filter: ['firstName', 'lastName', 'email'],
              fields: [
                  {
                      placeholder: 'Name',
                      width: 6,
                      column: 'headDeptName'
                  },
                  {
                      placeholder: 'Email',
                      width: 6,
                      column: 'headDeptEmail'
                  },
              ],
              dtElements: [
                  {
                      title: 'Name',
                      column: 'firstName'
                  },
                  {
                      title: 'Email',
                      column: 'email'
                  },
              ],
              affectedField: [
                  {
                      from: 'id',
                      to: 'headDeptId'
                  },
                  {
                      from: 'firstName',
                      to: 'headDeptName'
                  },
                  {
                      from: 'email',
                      to: 'headDeptEmail'
                  },
              ]
            },
        }
    },
    async created() {
        const departmentApi = api('department-list')
        this.departmentList = await departmentApi.get()

        const divisionApi = api('division-list')
        this.divisionList = await divisionApi.get()

        const roleApi = api('member-management/role')
        this.roleList = await roleApi.get()

        if(this.$route.query.id !== undefined) {
            const mmApi = api('member-management/detail')
            // this.mm = await mmApi.getWithParams(this.$route.query.id)

            const mmResult = await mmApi.getWithParams(this.$route.query.id)
            this.mm = mmResult[0]
            this.mmRole = mmResult[1]
        }
    },
    methods: {
        async save() {
            const mmApi = api('member-management')
            await mmApi.update(this.mm, this.$route.query.id)
            this.$router.push({ name: 'memberManagement' })
        },
        cancel() {
            this.$router.push({ name: 'memberManagement' })
        },
        finishLookup(data) {
            const currentMM = this.mm
            this.mm = {
                ...currentMM,
                ...data
            }
        },
        selectChange(data) {
            const currentData = this.mm
            this.mm = {
                ...currentData,
                ...data
            }
        },
    }
}
</script>